import { CSS_CLASSES } from "./constants";
import { TipsService } from "./service";

const overlay = document.querySelector(CSS_CLASSES.OVERLAY);
let Tips = null;

if (overlay instanceof HTMLElement) {
    Tips = new TipsService(overlay);
} else {
    console.warn("Overlay not found, TipsService not initialized");
}

export default Tips;
